import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { GeneralError } from "@/features/errors/general-error";

function InternalServerError() {
  // Read error from History State (passed during navigation)
  const error = useRouterState({
    select: (s) => s.location.state.error,
  });

  return <GeneralError error={error} />;
}

export const Route = createFileRoute("/(errors)/500")({
  component: InternalServerError,
});
